import React, { useEffect } from "react"
import { Col, Row } from "react-bootstrap"
import "./ConversionRules.css"
import { FeatureTypeList, FeatureTypeListHeading } from "./FeatureTypeList"
import { FeatureTypeMappingHeading, FeatureTypeMappingSide } from "./FeatureTypeMappingSide"
import { ConversionRuleEditorFooter } from "./ConversionRuleEditorFooter"
import { Prompt } from "react-router-dom"
import { AnyFeatureCatalogInfo, FeatureType } from "../../api/types"
import { PendingSpinnerCentered } from "../../components/Pending"
import { GetApi } from "../../api/api"

export interface FeatureCatalogInfo extends AnyFeatureCatalogInfo {
  featureTypes: FeatureType[]
}

const ConversionRuleEditorRoute = () => {
  const fcIdLeft = "1943" /* TODO hardcoded shall be replaced with url prop */
  const fcIdRight = "2022091504" /* TODO hardcoded shall be replaced with url prop */

  const [featureCatalogInfos, setFeatureCatalogInfos] = React.useState(null as null | FeatureCatalogInfo[])

  useEffect(() => {
    const getAnyFeatureTypes = async () => {
      const api = await GetApi()
      const fcInfos = await Promise.all(
        [fcIdLeft, fcIdRight].map(async (fcId) => {
          const fcInfo = await api.getAnyFeatureCatalogInfo(fcId)
          const featureTypes = (await api.getAnyFeatureTypes(fcId)).sort(compare)
          return { ...fcInfo, featureTypes }
        })
      )
      setFeatureCatalogInfos(fcInfos)
    }
    getAnyFeatureTypes()
  }, [fcIdLeft, fcIdRight])

  if (featureCatalogInfos) {
    return <ConversionRuleEditorInner featureCatalogInfos={featureCatalogInfos} />
  } else {
    return <PendingSpinnerCentered />
  }
}

const ConversionRuleEditorInner = (props: { featureCatalogInfos: FeatureCatalogInfo[] }) => {
  const [fcInfoLeft, fcInfoRight] = props.featureCatalogInfos

  return (
    <Col className="flex-grow-1 overflow-auto">
      <Col className="h-100 d-flex flex-column">
        <Prompt message={navigateWarningMessage} />
        <Row className="mb-1">
          Feature Type Mapping Diagram:&nbsp;<b>New Mapping 001</b>
        </Row>
        <Row className="small-custom text-muted border-top">
          <FeatureTypeListHeading left={true} fcInfo={fcInfoLeft} />
          <FeatureTypeMappingHeading fcInfo={fcInfoLeft} left={true} />
          <FeatureTypeMappingHeading fcInfo={fcInfoRight} left={false} />
          <FeatureTypeListHeading left={false} fcInfo={fcInfoRight} />
        </Row>
        <Row className="bg-white small-custom flex-grow-1 overflow-auto conversion-shadow">
          <FeatureTypeList left={true} fcInfo={fcInfoLeft} />
          <FeatureTypeMappingSide fcInfo={fcInfoLeft} left={true} />
          <FeatureTypeMappingSide fcInfo={fcInfoRight} left={false} />
          <FeatureTypeList left={false} fcInfo={fcInfoRight} />
        </Row>
        <ConversionRuleEditorFooter />
      </Col>
    </Col>
  )
}

interface FeatureTypeShort {
  id: number
  name: string
}

const compare = (ftShortA: FeatureTypeShort, ftShortB: FeatureTypeShort) => {
  return ftShortA.name.toUpperCase() > ftShortB.name.toUpperCase() ? 1 : -1
}

const navigateWarningMessage = "Any unsaved changes will be lost. Are you sure you want to leave?"

export default ConversionRuleEditorRoute
